import Vue from 'vue';
import Vuex, {Store} from 'vuex';
import {AscDesc, ResultType, XHTTPService} from '@/shared/xhttp';
import {
	PaginatorFilterState,
	PaginatorActionWithFilters,
	PaginatorMutation,
	StandardAction,
} from '@/shared/utils';
import {Temp} from '@/models';
import {TempService} from "@/xhttp/TempService";

import {DateFilter} from '@/shared/filter';
import store from '@/stores';

Vue.use(Vuex);

export class TempFilter {

	name: string = '';
	email: string = '';
	remarques: string = '';
	address: string = '';
	zipCode: string = '';
	town: string = '';
	country: string = '';

	public clear(): void {
		this.name = '';
		this.email = '';
		this.remarques = '';
		this.address = '';
		this.zipCode = '';
		this.town = '';
		this.country = '';
	}

	public toString(): string {
		return JSON.stringify(this);
	}
}

class TempState extends PaginatorFilterState<TempFilter> {
	temp: Temp = null;
	temps: ResultType<Temp> = null;
	public constructor() {
		super(new TempFilter(), 'temps', 'temp', 'id', AscDesc.DESC, 20)
	}
}

class TempStore {

	@XHTTPService(() => Temp)
	private tempService: TempService;
	private  _store: Store<any>;

	public state: TempState = new TempState();

	public mutations = {
		...PaginatorMutation(() => this._store, 'temps', 'temp'),
	};

	public actions = {
		...StandardAction<Temp, TempState>(() => Temp, 'temp'),
		...PaginatorActionWithFilters<Temp, TempState>(() => Temp, 'temps', 'temp'),
	};

	public init(store: Store<any>): this {
		this._store = store;
		return this;
	}

}

const instance = new TempStore();
const storeTemp = new Vuex.Store(instance);
instance.init(storeTemp);

const instancePrix = new TempStore();
export const storeTempPrix = new Vuex.Store(instancePrix);
instancePrix.init(storeTempPrix);

store.registerModule('temp', storeTemp);
store.registerModule('tempPrix', storeTempPrix);
export default storeTemp;